import { render, staticRenderFns } from "./business-registration.vue?vue&type=template&id=0c76c8d5&scoped=true"
import script from "./business-registration.vue?vue&type=script&lang=js"
export * from "./business-registration.vue?vue&type=script&lang=js"
import style0 from "./business-registration.vue?vue&type=style&index=0&id=0c76c8d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c76c8d5",
  null
  
)

export default component.exports